// extracted by mini-css-extract-plugin
export var rateTable = "_52-0";